import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'transfer/utils/p2p-connect'
import content from 'pp-react-l10n'
import { formatAmount } from '../utils/currencyUtils'
import { get } from 'lodash'
import { DONATION_VALIDATION_TYPES } from '../constants'

const i18n = content('transfer/inc/amount')

const STYLES = {
  error: {
    color: 'grey700',
    fontSize: '13px',
  },
  criticalIcon: {
    color: '#D20000',
    position: 'relative',
    top: '-2px',
    height: 13.18,
    width: 14.83,
  },
}

/**
 * Component for displaying amount validation error message
 */
export class AmountDonationValidationError extends Component {
  render() {
    if (
      this.props.donationValidationType ===
      DONATION_VALIDATION_TYPES.AMOUNT_VALID
    ) {
      return null
    }

    let errorMessageKey = 'errorText.minimumDonationUS'
    let amount = '1.00'
    let currencyCode = 'USD'

    if (
      this.props.donationValidationType ===
      DONATION_VALIDATION_TYPES.AMOUNT_ABOVE_MAXIMUM
    ) {
      amount = get(this.props.donationContext, 'maximum_amount.value')
      currencyCode = get(this.props.donationContext, 'maximum_amount.currency')
      errorMessageKey = 'errorText.maximumDonation'
    } else {
      amount = get(this.props.donationContext, 'minimum_amount.value', '1.00')
      currencyCode = get(
        this.props.donationContext,
        'minimum_amount.currency',
        'USD'
      )
      if (currencyCode === 'USD' && Number(amount) < 1) {
        amount = '1.00'
      }
      errorMessageKey = 'errorText.minimumDonationUS'
    }

    const formattedAmount = formatAmount(
      amount,
      currencyCode,
      'CURRENCY_FORMAT'
    )
    return (
      <span>
        <span
          className="icon icon-critical-small"
          style={{ ...STYLES.criticalIcon }}
          aria-hidden="true"
        />
        <span className="vx_text-3" style={STYLES.error}>
          {i18n(errorMessageKey, { amount: formattedAmount })}
        </span>
      </span>
    )
  }
}

AmountDonationValidationError.propTypes = {
  donationValidationType: PropTypes.string,
  donationContext: PropTypes.object,
}

export default connect(({ external }) => ({
  donationValidationType: external.donationValidationType,
  donationContext: external.donationContext,
}))(AmountDonationValidationError)
